import React from "react";
import { FooterName } from "../../Utility/constants";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: "black",
        color: "#6c757d",
        textAlign: "center",
        padding: "10px 0",
        boxShadow: "0 -1px 5px rgba(0, 0, 0, 0.1)",
        width: "100%",
        marginTop: "auto",  // Makes sure the footer stays at the bottom when content is short
      }}
    >
      <div className="container">
        <p className="mb-0" style={{ color: "white" }}>
          Copyright &copy; 2017-{currentYear} {FooterName} | All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
